import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';

export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const designationListAll = createAsyncThunk('/designation/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDesignation(data)
        return response.data;

    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})


export const designationSubListAll = createAsyncThunk('/designation/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDesignation(data)
        return response.data;

    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})



export const designationSlice = createSlice({
    name: 'designation',
    initialState,
    reducers: {

        designationList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(designationListAll.pending, (state) => {
                state.loading = false
            })
            .addCase(designationListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(designationSubListAll.pending, (state) => {
                state.subloading = false
            })
            .addCase(designationSubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    designationList


} = designationSlice.actions

export default designationSlice.reducer